import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import TimePicker from 'material-ui/TimePicker';
import Checkbox from 'material-ui/Checkbox';
import globals from '../../../globals/communityGlobals';

const localeConfigureTimeSlots = globals.getArea('configureTimeSlots');

function TimeSlotConfiguration(props) {
  return (
    <div className="configure-timeslots-row">
      <Box display="flex" alignItems="center">
        <Box p={1}>
          <div className="timeslot-trash">
            {props.enableDelete && (
              <i className="allocateIcons icon" role="button" onClick={props.deleteTimeSlot} tabIndex={-1}>
                delete
              </i>
            )}
          </div>
        </Box>
        <Box p={1}>
          <div className="timeslot-name">
            <span>{props.name}</span>
          </div>
        </Box>
        <Box p={1}>
          <div className="time-picker-column">
            <TimePicker
              id={`timeslot-from-time-${props.name}`}
              format="24hr"
              className="time-picker"
              textFieldStyle={{ width: '100%' }}
              value={props.from}
              onChange={props.fromTimeChange}
            />
          </div>
        </Box>
        <Box p={1}>
          <div className="time-picker-column">
            <TimePicker
              id={`timeslot-to-time-${props.name}`}
              format="24hr"
              className="time-picker"
              textFieldStyle={{ width: '100%' }}
              value={props.to}
              onChange={props.toTimeChange}
            />
          </div>
        </Box>
        <Box p={1}>
          <div className="twilight-hours-column" style={{ width: '220px' }}>
            <Checkbox
              id="timeslot-is-twilight"
              labelPosition="left"
              checked={props.isTwilight}
              onCheck={(event, isChecked) => props.setTimeSlotTwilight(isChecked)}
              label={localeConfigureTimeSlots.getMsg('makeTwilightHours')}
            />
          </div>
        </Box>
      </Box>
    </div>
  );
}

TimeSlotConfiguration.propTypes = {
  setTimeSlotTwilight: PropTypes.func.isRequired,
  deleteTimeSlot: PropTypes.func.isRequired,
  fromTimeChange: PropTypes.func.isRequired,
  toTimeChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  isTwilight: PropTypes.bool.isRequired,
  from: PropTypes.instanceOf(Date).isRequired,
  to: PropTypes.instanceOf(Date).isRequired,
};

export default TimeSlotConfiguration;
